import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import CTABtnModule from "../../modules/cta_btn_module";
import ContentModule from "../../modules/content_module";

import "./FindOut.scss";

const FindOut = ({Module}) => {
    return (
        <section className="find-out">
            <Container>
                <Row>
                    <Col>
                        <div className="find-out-wrapper">
                            <div className="find-content">
                                <div className="heading">
                                    <h2>{Module?.text_block?.title}</h2>
                                </div>

                                <div className="heading-content">
                                    {Module?.text_block?.description && <ContentModule Content={Module?.text_block?.description}/> }

                                    {Module?.link && <CTABtnModule button_cta={Module?.link} /> }
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
export default FindOut;
